import VanillaTilt from "vanilla-tilt";

export default function initTiltAnimation() {
  const supportsTilt = window.matchMedia(
    "(any-hover: hover) and (any-pointer: fine)"
  ).matches;
  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;
  if (!supportsTilt || prefersReducedMotion) return;

  const elements = document.querySelectorAll(".js-tilt");
  VanillaTilt.init(elements, {
    max: 3,
    speed: 800,
    glare: true,
    "max-glare": 0.3,
    perspective: 1200,
  });
}
